import { gql, useQuery } from "@apollo/client";

export const GET_TRADES_FOR_SELECTION = gql`
  query GetTradesForSelection {
    trades {
      id
      symbol
      date
      side
      notes
      walletId
      fee
      feePercentage
      feeCurrency
      positions {
        id
        quantity
        price
      }
    }
  }
`;

export const GET_TRADE_BY_ID = gql`
  query GetTradeById($id: Int!) {
    trade(id: $id) {
      id
      symbol
      date
      side
      notes
      walletId
      fee
      feePercentage
      feeCurrency
      positions {
        id
        quantity
        price
      }
    }
  }
`;

export const CREATE_TRADE = gql`
  mutation CreateTrade($createTradeInput: CreateTradeInput!) {
    createTrade(createTradeInput: $createTradeInput) {
      id
      symbol
      date
      side
      notes
      walletId
      fee
      feePercentage
      feeCurrency
    }
  }
`;

export const UPDATE_TRADE = gql`
  mutation UpdateTrade($id: Int!, $updateTradeInput: UpdateTradeInput!) {
    updateTrade(id: $id, updateTradeInput: $updateTradeInput) {
      id
      symbol
      date
      side
      notes
      walletId
      fee
      feePercentage
      feeCurrency
    }
  }
`;

export const DELETE_TRADE = gql`
  mutation DeleteTrade($id: Int!) {
    deleteTrade(id: $id) {
      id
    }
  }
`;

// Trade Hooks
export const useTradeById = (id: number) => {
  const { data, loading, error } = useQuery(GET_TRADE_BY_ID, {
    variables: { id },
    skip: !id,
  });

  return {
    trade: data?.trade,
    loading,
    error,
  };
};
